"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ajax_1 = require("./ajax");
var getIsLoggedIn = function (sitePath) {
    return new Promise(function (resolve, reject) {
        ajax_1.ajax(sitePath + "/ajax-verify-authorization").then(function (data) {
            if (data && data.isLoggedIn) {
                resolve(true);
            }
            else {
                resolve(false);
            }
        }, function (err) {
            reject(err);
        });
    });
};
exports.getIsLoggedIn = getIsLoggedIn;
var getDisplayName = function (sitePath) {
    return new Promise(function (resolve, reject) {
        ajax_1.ajax(sitePath + "/getDisplayName").then(function (data) {
            if (data && data.displayName) {
                resolve(data.displayName);
            }
            else {
                resolve('');
            }
        }, function (err) {
            reject(err);
        });
    });
};
exports.getDisplayName = getDisplayName;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3NvLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3Nzby50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLCtCQUE0QjtBQUU1QixJQUFNLGFBQWEsR0FBRyxVQUFDLFFBQWdCO0lBQ25DLE9BQU8sSUFBSSxPQUFPLENBQUMsVUFBQyxPQUFPLEVBQUUsTUFBTTtRQUMvQixXQUFJLENBQUksUUFBUSwrQkFBNEIsQ0FBQyxDQUFDLElBQUksQ0FDOUMsVUFBQSxJQUFJO1lBQ0EsSUFBSSxJQUFJLElBQUksSUFBSSxDQUFDLFVBQVUsRUFBRTtnQkFDekIsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO2FBQ2pCO2lCQUFNO2dCQUNILE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQzthQUNsQjtRQUNMLENBQUMsRUFDRCxVQUFBLEdBQUc7WUFDQyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDaEIsQ0FBQyxDQUNKLENBQUM7SUFDTixDQUFDLENBQUMsQ0FBQztBQUNQLENBQUMsQ0FBQztBQW1CTSxzQ0FBYTtBQWpCckIsSUFBTSxjQUFjLEdBQUcsVUFBQyxRQUFnQjtJQUNwQyxPQUFPLElBQUksT0FBTyxDQUFDLFVBQUMsT0FBTyxFQUFFLE1BQU07UUFDL0IsV0FBSSxDQUFJLFFBQVEsb0JBQWlCLENBQUMsQ0FBQyxJQUFJLENBQ25DLFVBQUEsSUFBSTtZQUNBLElBQUksSUFBSSxJQUFJLElBQUksQ0FBQyxXQUFXLEVBQUU7Z0JBQzFCLE9BQU8sQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLENBQUM7YUFDN0I7aUJBQU07Z0JBQ0gsT0FBTyxDQUFDLEVBQUUsQ0FBQyxDQUFDO2FBQ2Y7UUFDTCxDQUFDLEVBQ0QsVUFBQSxHQUFHO1lBQ0MsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ2hCLENBQUMsQ0FDSixDQUFDO0lBQ04sQ0FBQyxDQUFDLENBQUM7QUFDUCxDQUFDLENBQUM7QUFFcUIsd0NBQWMifQ==